import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
const groups = [{
  title: 'Get in the room',
  line: 'Podcasts, interviews, speaking, and content that opens doors.'
}, {
  title: 'Keep the conversation going',
  line: 'Follow-up, clearer calls to action, and stronger sales conversations.'
}, {
  title: 'Connect the right readers to the right work',
  line: 'Coaching, consulting, speaking, training, workshops, courses, certification, communities, and more.',
  emphasize: true
}];

/**
 * Simplified editorial business-payoff — three forms of author leverage.
 * Resting state is fully opaque for contrast (no faded/disabled look).
 */
export function BusinessPayoffV2() {
  return <section className="bg-[#1a2838] px-6 py-14 text-[#faf8f5] md:px-10 md:py-20" data-id="element-660" data-mp="1lcgj3f31gkau">
      <div className="mx-auto max-w-5xl" data-id="element-661" data-mp="e0g59au2eoxe">
        <div className="max-w-3xl" data-id="element-662" data-mp="e19ecighxqip">
          <Reveal data-id="element-663" data-mp="9yctel3hhibl">
            <Eyebrow data-id="element-664" data-mp="9y3atikrqdfx">Author leverage</Eyebrow>
            <h2 className="mt-3 font-serif text-3xl leading-[1.12] text-[#faf8f5] md:text-5xl" data-id="element-665" data-mp="9x1mwdinlwgs">
              <span className="block" data-id="element-666" data-mp="2fnm1dy6u6f92">Your book creates authority.</span>
              <span className="mt-1.5 block italic text-[#a8c4bb]" data-id="element-667" data-mp="2kkujxzvwclau">
                A Reader-to-Revenue path turns it into leverage.
              </span>
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-668" data-mp="2an6rxhpodrwd">
              Without that path, even interested readers can finish the book and
              disappear. You never learn what landed, what they need, or where
              they fit in the work behind your book.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-669" data-mp="1mynigyuw392p">
              We build the path that turns reader interest into action, useful
              context and better-fit business opportunity.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-670" data-mp="1dzjxtqg2qlm3">
          <p className="mt-10 text-xs font-semibold uppercase tracking-[0.22em] text-[#faf8f5]/55" data-id="element-671" data-mp="1iwaby88bj74v">
            What author leverage looks like:
          </p>
          <div className="mt-5 divide-y divide-white/15 border-y border-white/15" data-id="element-672" data-mp="3kn0w88uaizvl">
            {groups.map(g => <div key={g.title} className={`py-5 md:grid md:grid-cols-[7.5rem_minmax(0,14rem)_1fr] md:items-baseline md:gap-x-8 md:py-6 ${g.emphasize ? 'md:py-7' : ''}`} data-id="element-673" data-mp="3fswkzddzs5op">
                <p className={`text-[0.78rem] font-semibold uppercase tracking-[0.2em] ${g.emphasize ? 'text-[#d4a574]' : 'text-[#a8c4bb]'}`} data-id="element-674" data-mp="36vm7dldpc4gm">
                  Leverage to
                </p>
                <h3 className={`mt-2 font-serif leading-snug md:mt-0 ${g.emphasize ? 'text-2xl text-[#d4a574] md:text-3xl' : 'text-xl text-[#faf8f5] md:text-2xl'}`} data-id="element-675" data-mp="2h5wpgmgqw6h">
                  {g.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-[#faf8f5]/80 md:mt-0 md:text-lg" data-id="element-676" data-mp="3pkapjzksvvop">
                  {g.line}
                </p>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-677" data-mp="2e42ltutmuebg">
          <p className="mx-auto mt-10 max-w-3xl text-center font-serif text-2xl leading-snug text-[#faf8f5] md:text-3xl" data-id="element-678" data-mp="2e8064jry5bwx">
            That is the opportunity.
            <br data-id="element-679" data-mp="ynhgfpmqvg1j" />
            <span className="italic text-[#a8c4bb]" data-id="element-680" data-mp="ymxve01ssbja">
              But it is probably not what is happening now.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}